import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { DISTANT, cardConfig, tokens } from '../../constants';
export var getCardStyles = (props, showGradientBorder) => {
  var noPadding = props.noPadding,
    paddingToken = props.paddingToken,
    noHorizontalPadding = props.noHorizontalPadding,
    noVerticalPadding = props.noVerticalPadding,
    borderColor = props.borderColor,
    backgroundColor = props.backgroundColor,
    showShadow = props.showShadow,
    _props$withRoundedBor = props.withRoundedBorder,
    withRoundedBorder = _props$withRoundedBor === void 0 ? true : _props$withRoundedBor,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style;
  var spacing = tokens.spacing;
  var _padding = spacing === null || spacing === void 0 ? void 0 : spacing[paddingToken];
  var gradientContainerWidth = typeof style.width === 'number' ? style.width + 2 : style.width;
  return StyleSheet.create({
    container: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      borderWidth: showGradientBorder ? 0 : 1,
      borderStyle: 'solid'
    }, withRoundedBorder && {
      borderRadius: tokens.borderRadius.BORDER_RADIUS_16
    }), !noPadding && !noHorizontalPadding && {
      paddingHorizontal: _padding
    }), !noPadding && !noVerticalPadding && {
      paddingVertical: _padding
    }), !showGradientBorder && borderColor && {
      borderColor: borderColor
    }), backgroundColor && {
      backgroundColor: backgroundColor
    }), !!showShadow && DISTANT),
    gradientContainer: Object.assign(Object.assign({
      padding: 1
    }, withRoundedBorder && {
      borderRadius: 17
    }), {
      width: gradientContainerWidth || '100%'
    })
  });
};
export var getCardProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(cardConfig === null || cardConfig === void 0 ? void 0 : cardConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.card) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};